import { Product } from '@/services/models/implementations/Product'
import { Characteristic } from '@/services/models/Characteristic'
import { CharacteristicType } from '@/helper/Types.ts'

export class GeneralProduct extends Product {

  public get chr(): Characteristic {
    return { type: '' as CharacteristicType }
  }
}
